import PropTypes from 'prop-types';
import React from 'react';
import Headline from '../../atoms/headline/headline';
import MixedCopy from '../mixed-copy/mixedCopy';
import ArrowLink from '../arrow-link/arrowLink';
import StyledTeaserShaped from './teaserShaped.style';
import ShapedImage from '../shaped-image/shapedImage';
import { buildSrcSet } from '../../../helper/index';

const TeaserShaped = props => {
  const {
    introCopy,
    headline,
    titleImage,
    teaserImage,
    subline,
    uri,
    title,
    onClick = () => {},
    ...rest
  } = props;
  let usedImage = {};
  // Check if teaserImage is an array
  let teaserImageTmp = teaserImage;
  if (Array.isArray(teaserImageTmp)) {
    [teaserImageTmp] = teaserImageTmp; // Use the first element if it's an array
  }
  // Check if titleImage is an array
  let titleImageTmp = titleImage;
  if (Array.isArray(titleImageTmp)) {
    [titleImageTmp] = titleImage; // Use the first element if it's an array
  }

  if (teaserImageTmp && (teaserImageTmp?.src || teaserImageTmp?.url)) {
    usedImage = teaserImageTmp;
  } else if (titleImageTmp && (titleImageTmp?.src || titleImageTmp?.url)) {
    usedImage = titleImageTmp;
  }
  let usedImageSrscet = usedImage.srcset;
  if (Array.isArray(usedImageSrscet)) {
    usedImageSrscet = buildSrcSet(usedImageSrscet);
  }

  return (
    <StyledTeaserShaped {...rest}>
      <div className="teaser__container">
        <div className="teaser__image">
          <ShapedImage
            clipForm="polygon(8% 0, 59% 11%, 67% 34%, 43% 100%, 0 88%)"
            onlyBackground
            shadowY="top"
            shadow="left"
            alt={usedImage.alt ?? headline}
            src={usedImage?.url ?? usedImage?.src}
            srcset={usedImageSrscet ?? ''}
            sizes="(min-width: 768px) 50vw, 100vw"
            shadowSize="xxl"
          />
        </div>
        <div className="teaser__content">
          <div className="teaser__headlines">
            {subline && <Headline tag="span">{subline}</Headline>}
            {(headline || title) && (
              <Headline tag="h3" secondary>
                {headline ?? title}
              </Headline>
            )}
          </div>
          {introCopy && (
            <MixedCopy
              fullWidth
              html={introCopy.length > 200 ? `${introCopy.substring(0, 200)}...` : introCopy}
            />
          )}
          {uri && (
            <div className="teaser__link">
              <ArrowLink onClick={onClick} href={uri} stretched />
            </div>
          )}
        </div>
      </div>
    </StyledTeaserShaped>
  );
};

TeaserShaped.propTypes = {
  titleImage: PropTypes.arrayOf(PropTypes.shape()),
  teaserImage: PropTypes.arrayOf(PropTypes.shape()),
  headline: PropTypes.string,
  title: PropTypes.string.isRequired,
  subline: PropTypes.string,
  introCopy: PropTypes.string,
  uri: PropTypes.string,
  onClick: PropTypes.func
};

export default TeaserShaped;
